import { render, staticRenderFns } from "./ApprovalReport.vue?vue&type=template&id=af885f46"
import script from "./ApprovalReport.vue?vue&type=script&lang=js"
export * from "./ApprovalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports